import React from 'react'

export const IgnoreNote = ({ mode, text }) => {
    if (mode !== 'ignore') return null

    return (
        <div className="ff-ignore-note">
            <i className="fal fa-lock-open" />
            <div className="ff-ignore-note__title">This check is off — everyone passes it</div>
            <div>{text}</div>
        </div>
    )
}
